/** Label for the sign-up notebook cover: "Ada’s notebook", from whatever is typed so far. */
export function notebookTitle(name: string): string {
  const first = name.trim().split(/\s+/)[0] ?? '';
  if (!first) return 'Your notebook';
  return first.toLowerCase().endsWith('s') ? `${first}’ notebook` : `${first}’s notebook`;
}
